<template>

  <!-- Page Sidebar Ends-->
         <div class="container-fluid  bg-primary ">
            <div class="page-title">
              <div class="row">
                <div class="col-12">
                 <img class="img-fluid for_logo" src="../../../assets/images/logo/logo.png"
                                    alt="looginpage">
                </div>
               
              </div>
            </div>
          </div>
         
    <div class="container-fluid">
      <div class="row  p-2 ">
        <div class="col-xxl-12 box-col-12">
          <div class="row">
            <div class="col-xl-3 col-sm-12 col-12">
              <router-link to="TabGatepass">
                <div class="card o-hidden small-widget">
                     <div class="card-body total-project border-b-primary border-2"><span
                              class="f-light f-w-500 f-14"></span>
                            <div class="project-details">
                                 <h4 class="project-counter">Create Gatepass</h4>
                              <div class="product-sub bg-primary-light">
                                <i class="icofont icofont-plus"></i>
                              </div>
                            </div>
                          </div>
                  
               
                </div>
              </router-link>
            </div>
            <div class="col-xl-3 col-sm-12  col-12">
              <router-link to="TabScan">
                <div class="card o-hidden small-widget">
                  <div class="card-body total-project border-b-danger border-2"><span
                      class="f-light f-w-500 f-14"> </span>
                      
                      <div class="project-details">
                                 <h4 class="project-counter">Scan Gatepass</h4>
                              <div class="product-sub bg-primary-light">
                                <i class="icofont icofont-qr-code"></i>
                              </div>
                            </div>
                            
                  
                  </div>
                </div>
              </router-link>
            </div>
            <div class="col-xl-3 col-sm-12  col-12">
              <router-link to="TabWorkPermit">
                <div class="card o-hidden small-widget">
                  <div class="card-body total-project border-b-danger border-2"><span
                      class="f-light f-w-500 f-14"> </span>
                      
                      <div class="project-details">
                                 <h4 class="project-counter">Create Workpermit</h4>
                              <div class="product-sub bg-primary-light">
                                <i class="icofont icofont-tools"></i>
                              </div>
                            </div>
                            
                  
                  </div>
                </div>
              </router-link>
            </div>
            <div class="col-xl-3 col-sm-12  col-12">
              <router-link to="MobileScan">
                <div class="card o-hidden small-widget">
                  <div class="card-body total-project border-b-danger border-2"><span
                      class="f-light f-w-500 f-14"> </span>
                      
                      <div class="project-details">
                                 <h4 class="project-counter">Mobile Scan</h4>
                              <div class="product-sub bg-primary-light">
                                <i class="icofont icofont-qr-code"></i>
                              </div>
                            </div>
                            
                  
                  </div>
                </div>
              </router-link>
            </div>
           <button class="btn btn-sm btn-danger" @click="this.$router.go(-1);">Go Back</button>
          </div>
        </div>

        
      </div>
    </div>
    <!-- Container-fluid Ends-->
 



</template>
<style scoped>
.meet_success{
  background: #97ff8d;
  padding: 5px;
}.meet_pending{
  background: #f7f7f7;
  padding: 5px;
}
.accordion-item{
  padding: 5px;
}
  </style>
<script>
import PageTitle from '@/components/PageTitle.vue';
// import axios from 'axios';
import axios from "@/plugins/axios";

export default {
  name: 'SecurityDashboard',
  components: {
    PageTitle
  },
  mounted() {
    this.getDashboard();
  },
  data() {
    return {
      emp: [name => '', dept => '', empcode => '', role => ''],
      today_gatepasses: [],
      today_gatepasses_active: [],
      today_gatepasses_done: [],
      today_veh_req: [],
      otp: '',
      all_reservations: [],
      emergency:{msg:'',option:''}
    }
  },
  methods: {
    getDashboard() {
      var self = this;

      if (localStorage['token']) {
        axios.post('getDashboard', { token: localStorage['token'] }).then(function (response) {
          if (response.data.is == 1) {
            self.emp = response.data.emp;
            self.today_gatepasses = response.data.today_gatepasses;
            self.today_gatepasses_active = response.data.today_gatepasses_active;
            self.today_gatepasses_done = response.data.today_gatepasses_done;
            self.today_veh_req = response.data.today_veh_req; 
          } else {
          }
        });
      }
    },
        saveEmergency() {
            var self = this;
            if(!self.emergency.msg){
              self.$swal("Enter Emergency Message");
            }else if (!self.emergency.option) { // ✅ fixed here
        self.$swal("Enter Emergency Option");
    }else{
            self.$swal({
                title: "Do You Want To Send Alert?",
                text: "Just For Confirmation !",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Yes"
            }).then((result) => { // <--
                if (result.value) { // <-- if confirmed
                    axios.post('sendEmergency', { emergency: this.emergency }).then(function (response) {
                        if(response.data.status==1)
                          self.emergency={msg:'',option:''};

                        self.$swal(response.data.msg);

                        
                    });
                }
            });

        }
      }
        
  }
}
</script>
